import { render, staticRenderFns } from "./Gauge.vue?vue&type=template&id=cbfb21c6&scoped=true"
import script from "./Gauge.vue?vue&type=script&lang=js"
export * from "./Gauge.vue?vue&type=script&lang=js"
import style0 from "./Gauge.vue?vue&type=style&index=0&id=cbfb21c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfb21c6",
  null
  
)

export default component.exports